import React, { Component } from "react";
import { manageChatbotVisibility, setupChatbotVisibilityCheck } from "../../utils/chatbotUtils";

class WhatsAppButton extends Component {
  constructor(props) {
    super(props);
    this.chatbotInterval = null;
    this.link = props.link || "https://wa.me/5511972486650";
  }

  componentDidMount() {
    
    if (window.location.href.includes("luxo")) return;

    if (document.querySelector(".chatbot-element")) return;

    // Criar estilos
    const style = document.createElement("style");
    style.innerHTML = `
      .whatsapp-container {
        position: fixed;
        bottom: 20px;
        right: 20px;
        display: flex;
        align-items: center;
        z-index: 9999;
        font-family: Arial, sans-serif;
      }

      .whatsapp-text {
        background: #25D366;
        color: white;
        padding: 5px 20px;
        border-radius: 30px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 10px;
        white-space: nowrap;
        box-shadow: 0 4px 10px rgba(0,0,0,0.2);
        opacity: 0;
        visibility: hidden;
        transform: translateX(10px);
        transition: all 0.3s ease;
      }

      .whatsapp-container:hover .whatsapp-text {
        opacity: 1;
        visibility: visible;
        transform: translateX(0);
      }

      .whatsapp-icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .whatsapp-icon img {
        width: 56px;
        height: 56px;
      }

      .whatsapp-container a {
        text-decoration: none;
      }

      @media (max-width: 768px) {
        .whatsapp-container {
          bottom: calc(60px + env(safe-area-inset-bottom));
          right: 8px;
        }

        .whatsapp-text {
          display: none;
        }

        .whatsapp-icon {
          width: 56px;
          height: 56px;
        }
      }
    `;
    document.head.appendChild(style);

    
    const container = document.createElement("div");
    container.className = "whatsapp-container chatbot-element";

    
    const textLink = document.createElement("a");
    const iconLink = document.createElement("a");

    textLink.href = this.link;
    iconLink.href = this.link;

    textLink.target = "_blank";
    iconLink.target = "_blank";
    textLink.rel = "noopener noreferrer";
    iconLink.rel = "noopener noreferrer";

    textLink.innerHTML = `<div class="whatsapp-text">Entre em contato</div>`;
    iconLink.innerHTML = `
      <div class="whatsapp-icon">
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        />
      </div>
    `;

      container.appendChild(textLink);
      container.appendChild(iconLink);
      document.body.appendChild(container);

      
    this.chatbotInterval = setupChatbotVisibilityCheck();
  }

  componentWillUnmount() {
    if (this.chatbotInterval) {
      clearInterval(this.chatbotInterval);
    }
  }

  componentDidUpdate() {
    manageChatbotVisibility();
  }

  render() {
    return null;
  }
}

export default WhatsAppButton;